import { useFormik } from 'formik';
import {
  InputField,
  Textarea,
} from '../../components/FormElements/FormElements';
import Grid from '@mui/material/Grid';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import  { company } from '../../services/api/api';
import GreenButton from '../../components/buttons/green-button';
import { useTranslation } from 'react-multi-lang';
import { useNotification } from '../../services/usenotification';
import { Cancel, Save } from '@mui/icons-material';
import WhiteButton from '../../components/buttons/white-button';
import { Tooltip } from '@mui/material';
import * as Yup from 'yup'
import { useCookies } from 'react-cookie';
import { havePermission } from '../../services/hoc/permissions';
import SettingContext from '../../services/context/setting-contentxt/setting-context';
import { useAPI } from '../../services/hoc/useAPI';
export const CompanyInfo = () => {
  const [has_change, setHasChange] = useState(false);
  const { company_id } = useParams();
  const navigate = useNavigate();
  const [sending, setSending] = useState(false);
  const [_, setCookie] = useCookies();
  const {isMobile}=useContext(SettingContext)
  const [edit,setEdit]=useState(false)
  const { alert, alertError500 } = useNotification();
 

  const ENDPOINTS = useAPI()
  const t = useTranslation();
  const formik = useFormik({
    initialValues: {
      id: 0,
      name: '',
      commercial_name: '',
      country: '',
      city: '',
      post_code: '',
      address: '',
      email: '',
      phone: '',
      fax: '',
      website: '',
      description: '',
      tax_number: '',
      tax_percent: '',
      logo: 'test',
      created_at: null,
      updated_at: null,
      country_ar:'',
      city_ar:'',
      address_ar:'',
      name_ar:'',
      commercial_registrar_number:'',
      commercial_name_ar:''
    },
    onSubmit: () => {},
    validationSchema: Yup.object(
      {
        name: Yup.string().required(t('required_error')),
        commercial_name: Yup.string().required(t('required_error')),
        country: Yup.string().required(t('required_error')),
        city: Yup.string().required(t('required_error')),
        post_code: Yup.string().notRequired(),
        address: Yup.string().notRequired(),
   
        fax: Yup.string().required(t('required_error')),

        description: Yup.string().notRequired(),
        tax_number: Yup.string().required(t('required_error')),
        tax_percent: Yup.string().required(t('required_error')),
        country_ar:Yup.string().required(t('required_error')),
        city_ar:Yup.string().required(t('required_error')),
        address_ar:Yup.string().notRequired(),
        name_ar:Yup.string().required(t('required_error')),
        commercial_registrar_number:Yup.string().required(t('required_error')),
        commercial_name_ar:Yup.string().required(t('required_error'))

      }
    )
  });

  const customChange = (e: React.ChangeEvent) => {
    if(!edit) return
    formik.handleChange(e);
    if (!has_change) setHasChange(true);
  };
  const fetchData = (id: string) => {
    ENDPOINTS.company()
      .show({ id: Number(company_id) })
      .then((response: any) => {
        let company: company = response.data.data;

        formik.resetForm({ values: company });
      });
  };
  const saveChange = () => {
    if (!formik.isValid) {
      let error_fields:any={}
      Object.keys(formik.errors).map(ele=> {
        error_fields[ele]=true
      })
      formik.setTouched(error_fields)
      return
    }
    setSending(true);
    ENDPOINTS.company()
      .update({...formik.values,logo:'test'})
      .then((res: any) => {
        setSending(false);
        if (res.data.data) {
          alert(
            { en: 'changes saved successfully', ar: 'تم الحفظ بنجاح' },
            'success',
          );
          setEdit(false)
          formik.resetForm({ values: res.data.data });
          setCookie('company_info', res.data.data);
        } else {
          alert({ en: 'something wrong happend', ar: 'حدث خطأ ما' }, 'error');
        }
      })
      .catch((err: any) => {
        setSending(false);
        alertError500(err);
      });
  };
  const deleteCompany = () => {
    if (company_id) {
      ENDPOINTS.company()
        .delete({ ids: [Number(company_id)] })
        .then((res: any) => {
          if (res) {
            alert(
              { en: 'company deleted successfully', ar: 'تم الحذف بنجاح' },
              'success',
            );
          }
        })
        .catch((err: any) => {
          alertError500(err);
        });
    }
  };
  useEffect(() => {
    if (company_id) {
      fetchData(company_id);
    }
  }, [company_id]);
  return (
    <Grid container rowGap={2} padding={2}>
        <style>
        {`
          .icon-edit::before {
            position:absolute;
          }`
          }
        
      </style>
      {/* <Grid item container xs={12} justifyContent={"flex-end"}>
        <Backbutton  previousPageRoute='/company-info'/>
      </Grid> */}
      <Grid  container size={12} justifyContent={'center'}>
        <span style={{ fontSize:isMobile?'1rem' :'1.3rem', fontWeight: 'bold' }}>
          {t('company_info')}
        </span>
        <div className="show-on-hover"
         style={{display:'flex' ,alignItems:'center'}}>
{!edit
&& havePermission("Edit Company") &&

        <Tooltip title={t('edit')}>
                      <i
                        className="icon-edit"
                        style={{color:'blue'}}
                        onClick={() => {
                        setEdit(true)
                        }}
                      />
        </Tooltip>}
        </div>
      </Grid>
      <Grid  container size={12} sx={{columnGap:{sm:2,xs:0},justifyContent:{sm:'center',xs:'normal'}}} >
        <Grid size={{sm:4,xs:12}}  >
          <InputField
            value={formik.values.name}
            name="name"
            label={t("name")+t("en")}
            onChange={customChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && formik.errors.name?formik.errors.name:''}
            
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.name_ar}
            name="name_ar"
            label={t("name_ar")}
            onChange={customChange}
            error={formik.touched.name_ar && formik.errors.name_ar?formik.errors.name_ar:''}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.commercial_name}
            name="commercial_name"
            label={t("commercial_name")+ t("en")}
            onChange={customChange}
            error={formik.touched.commercial_name && formik.errors.commercial_name?formik.errors.commercial_name:''}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.commercial_name_ar}
            name="commercial_name_ar"
            label={t("commercial_name_ar")}
            onChange={customChange}
              error={formik.touched.commercial_name_ar && formik.errors.commercial_name_ar?formik.errors.commercial_name_ar:''}
          
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.country}
            name="country"
            label={t("country")+t("en")}
            onChange={customChange}
             error={formik.touched.country && formik.errors.country?formik.errors.country:''}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.country_ar}
            name="country_ar"
            label={t("country_ar")}
            onChange={customChange}
             error={formik.touched.country_ar && formik.errors.country_ar?formik.errors.country_ar:''}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.city}
            name="city"
            label={t("city")+t("en")}
            onChange={customChange}
              error={formik.touched.city && formik.errors.city?formik.errors.city:''}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.city_ar}
            name="city_ar"
            label={t("city_ar")}
            onChange={customChange}
             error={formik.touched.city_ar && formik.errors.city_ar?formik.errors.city_ar:''}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.address}
            name="address"
            onChange={customChange}
            label={t("address")+t("en")}
             error={formik.touched.address && formik.errors.address?formik.errors.address:''}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.address_ar}
            name="address_ar"
            onChange={customChange}
            label={t("address_ar")}
             error={formik.touched.address_ar && formik.errors.address_ar?formik.errors.address_ar:''}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.email}
            name="email"
            label={t("email")}
            onChange={customChange}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.fax}
            name="fax"
            label={t("fax")}
            onChange={customChange}
          />
        </Grid>
       
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.phone}
            name="phone"
            label={t("phone")}
            onChange={customChange}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.website}
            name="website"
            label={t("website")}
            onChange={customChange}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.post_code}
            name="post_code"
            label={t("post_code")}
            onChange={customChange}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.tax_number}
            name="tax_number"
            label={t("tax_number")}
            onChange={customChange}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.commercial_registrar_number}
            name="commercial_registrar_number"
            label={t("commercial_registrar_number")}
            onChange={customChange}
            error={formik.touched.commercial_registrar_number && formik.errors.commercial_registrar_number?formik.errors.commercial_registrar_number:''}
          />
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <InputField
            value={formik.values.tax_percent}
            name="tax_percent"
            label={t("tax_percent")}
            onChange={customChange}
          />
        </Grid>
       
        <Grid size={{sm:8,xs:12}} >
          <Textarea
            value={formik.values.description}
            name="description"
            label={t("description")}
            onChange={customChange}
          />
        </Grid>
      </Grid>
      <Grid  container size={12} justifyContent={"center"}>
        {edit && (
          <>
            <Grid  container size={3} alignItems="end" mx={1}>
              <GreenButton
                fullWidth={true}
                fun={() => saveChange()}
                label={t('save')}
                loading={sending}
              >
                <Save sx={{ color: 'white' }} />
              </GreenButton>
            </Grid>
            <Grid  size={3} mx={1}>
              <WhiteButton
                label={t('cancel')}
                fun={() => {
                  formik.resetForm();
                  navigate('/company-info');
                }}
                fullWidth={true}>
                <Cancel color="error" />
              </WhiteButton>
            </Grid>
          </>
        )}
        {/* <Grid item container xs={3} alignItems="end" mx={1}>
          {/* { <WhiteButton
            fullWidth={true}
            fun={() =>
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => deleteCompany(),
              })
            }
            label={t('delete')}>
            <Delete sx={{ color: 'red' }} />
          </WhiteButton> } 
        </Grid> */}
      </Grid>
    </Grid>
  );
};
